import React, { Component } from "react";
import { useForm } from "react-hook-form";

// Redux
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import logodark from "../../assets/images/logo.svg";

// Actions
import { registerUser, registerUserFailed, apiError } from '../../store/actions';

class Register extends Component {
    componentDidMount() {
        this.props.registerUserFailed("");
        this.props.apiError("");
        document.body.classList.add("auth-body-bg");
    }

    componentWillUnmount() {
        document.body.classList.remove("auth-body-bg");
    }

    render() {
        return (
            <RegisterForm
                user={this.props.user}
                registrationError={this.props.registrationError}
                loading={this.props.loading}
                onRegisterUser={this.props.registerUser}
            />
        );
    }
}

function RegisterForm({ user, registrationError, loading, onRegisterUser }) {
    const { register, handleSubmit, formState: { errors } } = useForm({
        defaultValues: {
            email: "",
            username: "",
            password: ""
        }
    });

    const onSubmit = (data) => {
        onRegisterUser(data);
    };

    return (
        <React.Fragment>
            <div className="w-full">
                <div className="flex min-h-screen justify-center items-center flex-col py-5 bg-gray-50">
                    <div className="mb-6">
                        <Link to="/">
                            <img
                                src={logodark}
                                alt="logo"
                                className="mx-auto h-16"
                            />
                        </Link>
                    </div>

                    <div className="bg-white shadow-lg rounded-2xl w-full max-w-md">
                        <div className="p-6 flex items-center">
                            <div className="w-full">
                                <div className="text-center">
                                    <h4 className="text-2xl font-semibold mt-2">Register Account</h4>
                                    <p className="text-gray-500 text-base">Get your free ValSabji account now.</p>
                                </div>

                                {user && (
                                    <div className="mt-4 p-2 text-sm text-green-700 bg-green-100 border border-green-300 rounded">
                                        Registration Done Successfully.
                                    </div>
                                )}
                                {registrationError && (
                                    <div className="mt-4 p-2 text-sm text-red-700 bg-red-100 border border-red-300 rounded">
                                        {registrationError}
                                    </div>
                                )}

                                <form onSubmit={handleSubmit(onSubmit)} className="mt-6 space-y-5">
                                    <div>
                                        <label htmlFor="useremail" className="block text-sm font-medium text-gray-700">
                                            Email
                                        </label>
                                        <input
                                            type="email"
                                            id="useremail"
                                            {...register("email", {
                                                required: "Email is required",
                                                pattern: {
                                                    value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                                                    message: "Invalid email format",
                                                },
                                            })}
                                            placeholder="Enter email"
                                            className={`mt-1 block w-full rounded-lg border px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.email ? "border-red-500" : "border-gray-300"
                                                }`}
                                        />
                                        {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email.message}</p>}
                                    </div>

                                    <div>
                                        <label htmlFor="username" className="block text-sm font-medium text-gray-700">
                                            Username
                                        </label>
                                        <input
                                            type="text"
                                            id="username"
                                            {...register("username", { required: "Username is required" })}
                                            placeholder="Enter username"
                                            className={`mt-1 block w-full rounded-lg border px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.username ? "border-red-500" : "border-gray-300"
                                                }`}
                                        />
                                        {errors.username && <p className="text-red-500 text-xs mt-1">{errors.username.message}</p>}
                                    </div>

                                    <div>
                                        <label htmlFor="userpassword" className="block text-sm font-medium text-gray-700">
                                            Password
                                        </label>
                                        <input
                                            type="password"
                                            id="userpassword"
                                            {...register("password", { required: "Password is required" })}
                                            placeholder="Enter password"
                                            className={`mt-1 block w-full rounded-lg border px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.password ? "border-red-500" : "border-gray-300"
                                                }`}
                                        />
                                        {errors.password && <p className="text-red-500 text-xs mt-1">{errors.password.message}</p>}
                                    </div>

                                    <div className="text-center">
                                        <button
                                            type="submit"
                                            className="w-full bg-blue-600 text-white py-2 rounded-lg shadow hover:bg-blue-700 transition"
                                        >
                                            {loading ? "Loading ..." : "Register"}
                                        </button>
                                    </div>

                                    <p className="text-center text-xs text-gray-500 mt-2">
                                        By registering you agree to the ValSabji{" "}
                                        <Link to="#" className="text-blue-600 hover:underline">
                                            Terms of Use
                                        </Link>
                                    </p>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div className="mt-6 text-center text-sm text-gray-600">
                        <p>
                            Already have an account?{" "}
                            <Link to="/login" className="text-blue-600 hover:underline font-medium">
                                Login
                            </Link>
                        </p>
                        <p className="mt-2 text-xs text-gray-400">
                            © 2025 ValSabji. Crafted with{" "}
                            <span className="text-red-500">♥</span> by{" "}
                            <Link to="https://www.valbeneti.com" target="_blank" rel="noreferrer" className="hover:underline">
                                ValBeneti Ltd
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

const mapStatetoProps = state => {
    const { user, registrationError, loading } = state.Account;
    return { user, registrationError, loading };
}

export default connect(mapStatetoProps, { registerUser, apiError, registerUserFailed })(Register);
